import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "/statistics";
const statisticApi = {
  dailyUserStatistics(params: any): Promise<any> {
    const url = `${path}/users`;
    return api.get(url, {
      ...params,
    });
  },
  summaryStatistics(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, {
      ...params,
      type: "summary",
    });
  },
  hotStatistics(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, {
      ...params,
      type: "feed",
    });
  },
  wallpaperStatistics(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, {
      ...params,
      type: "wallpaper",
    });
  },
  photocardNewsStatistics(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, {
      ...params,
      type: "photo_news",
    });
  },
  snapStatistics(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, {
      ...params,
      type: "snap",
    });
  },
  pushStatistics(params: any): Promise<any> {
    const url = `${path}/push`;
    return api.get(url, {
      ...params,
    });
  },

  barStatistics(params: any): Promise<any> {
    const url = `${path}/bars`;
    return api.get(url, {
      ...params,
    });
  },
  acquisitionStatistics(params: any = {}): Promise<any> {
    const url = `${path}/acquisitions`;
    return api.get(url, params);
  },
  regionalStatistics(params: any = {}): Promise<any> {
    const url = `${path}/regionals`;
    return api.get(url, params);
  },
  UVLogBarStatistics(params: any = {}): Promise<any> {
    const url = `${path}/bars/user-logs`;
    return api.get(url, params);
  },
};
export default statisticApi;
